module.exports = __webpack_public_path__ + "static/media/SaturdayEarth.55894485.md";